export const UPDATE_PROJECT_REQUEST = " UPDATE_PROJECT_REQUEST";
export const UPDATE_PROJECT_SUCCESS = " UPDATE_PROJECT_SUCCESS";
export const UPDATE_PROJECT_FAILURE = " UPDATE_PROJECT_FAILURE";
